import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('page.notFound.documentTitle');

    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [t]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <h1 className="font-heading text-[8rem] md:text-[12rem] text-background-200 select-none pointer-events-none leading-none">
          404
        </h1>
        <div className="relative z-10 -mt-8 md:-mt-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-6">
            {t('page.notFound.heading')}
          </h2>
          <p className="font-body text-sm text-foreground-500 mt-2">{location.pathname}</p>
          <button
            onClick={() => navigate('/')}
            className="mt-6 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-950 font-body text-sm font-semibold px-6 py-3 rounded-full transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            {t('page.notFound.backBtn')}
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}